import { InspectionStatus } from 'api';
import { useTranslation } from 'i18n';
import { Box, Link, Stack, Tooltip, Typography } from 'ui';

export const EvidenceInspectionSessionDetails = ({
  slug,
  deal,
  linkToExternalReport,
  currentStatus,
}: {
  slug: string;
  deal?: number;
  linkToExternalReport?: string | null;
  currentStatus: InspectionStatus;
}) => {
  const { t } = useTranslation('features');
  const externalReportLink = linkToExternalReport || `https://drive.google.com/drive/search?q=${slug}`;
  const dealLink = deal ? `/post-deal/dealhub/deal/details/${deal}` : '';
  // link should be displayed only after inspection was completed
  const showLink = currentStatus === InspectionStatus.CO;

  return (
    <Stack>
      <Stack direction="row" spacing={1}>
        <Typography>{t('evidence.inspectionSessionDetails.labels.inspectionSlug')}</Typography>
        {showLink ? (
          <Tooltip
            title={
              linkToExternalReport
                ? t('evidence.inspectionSessionDetails.tooltips.viewExternalReport')
                : t('evidence.inspectionSessionDetails.tooltips.searchInDrive')
            }
          >
            <Link data-testid="external-report-link" href={externalReportLink} target="_blank">
              {slug}
            </Link>
          </Tooltip>
        ) : (
          <Tooltip title={t('evidence.inspectionSessionDetails.tooltips.reportAvailableOnCompletion')}>
            <Box>{slug}</Box>
          </Tooltip>
        )}
      </Stack>
      {deal ? (
        <Stack direction="row" spacing={1}>
          <Typography>{t('evidence.inspectionSessionDetails.labels.dealId')}</Typography>
          <Tooltip title={t('evidence.inspectionSessionDetails.tooltips.viewDealDetails')}>
            <Link data-testid="deal-link" href={dealLink} target="_blank">
              {deal}
            </Link>
          </Tooltip>
        </Stack>
      ) : null}
    </Stack>
  );
};
